import {
  Button,
  FormControl,
  FormErrorMessage,
  Grid,
  Box,
  Center,
  Input,
  Checkbox,
  FormLabel,
  Flex,
  Spinner,
  InputGroup,
  Select,
  Heading,
  InputRightElement,
  Stack,
  Text,
  Image,
  useColorModeValue,
} from "@chakra-ui/react";
import { Field, Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useGetState } from "../../context/useGetState";
import image from "../../assets/image.jpeg";
import splash from "../../assets/splash.jpg";
import arrow from "../../assets/arrow.svg";
import logo from "../../assets/logo.png";
import { _register } from "./service";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

function EmailScreen({ next, prev, setPrevStep, ...props }) {
  const { dispatch } = useGetState();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  const submit = async (values) => {
    setLoading(true);
    const payload = {
      username: values.username,
      email: values.email,
      password: values.password,
    };
    dispatch({ payload });

    // Save username to sessionStorage
    sessionStorage.setItem("username", values.username);
    sessionStorage.setItem("email", values.email);
    sessionStorage.setItem("password", values.password);
    const result = await _register(payload, next, setLoading);
    sessionStorage.setItem("step_progress", true);
    sessionStorage.setItem("code", result?.data);
    setLoading(false);

    result ? navigate("/register/otp") : navigate("/register");
    //result ? navigate("/register/bio") : navigate("/register");
  };

  const totalStep = sessionStorage.getItem("totalStep" || 0);
  const handleNext = () => {
    next(); // Call the prev function to go back to EmailScreen
  };

  const inputStyle = {
    bg: "#fff",
    color: "#000",
    _placeholder: { color: "#000" },
  };

  const formikRef = useRef(null); // Create a ref for Formik

  useEffect(() => {
    // Retrieve values from sessionStorage
    const email_initialValue = sessionStorage.getItem("email") || "";
    const password_initialValue = sessionStorage.getItem("password") || "";
    const username_initialValue = sessionStorage.getItem("username") || "";

    // Set initial values using Formik ref
    if (formikRef.current) {
      formikRef.current.setFieldValue("email", email_initialValue);
      formikRef.current.setFieldValue("password", password_initialValue);
      formikRef.current.setFieldValue("username", username_initialValue);
    }
  }, []); // Empty dependency array

  return (
    <>
      <Center
        backgroundImage={splash}
        h={{
          base: "100vh",
          sm: "100vh",
          md: "100vh",
          lg: "100vh",
          xl: "100vh",
          "2xl": "100vh",
        }}
      >
        <Grid>
          <Box
            as="form"
            onSubmit={handleSubmit(submit)}
            backgroundColor={"#020B19"}
            mb={{ base: "0", sm: "0", md: "0", lg: "0", xl: "0", "2xl": "0" }}
            mt={{
              base: "2em",
              sm: "2em",
              md: "2em",
              lg: "2em",
              xl: "2em",
              "2xl": "2em",
            }}
            h={{
              base: "90vh",
              sm: "85vh",
              md: "90vh",
              lg: "88vh",
              xl: "80vh",
              "2xl": "80vh",
            }}
            w={{
              base: "100vw",
              sm: "100vw",
              md: "60vw",
              lg: "60vw",
              xl: "60vw",
              "2xl": "60vw",
            }}
            borderWidth={1}
            borderColor={"#66666680"}
            borderRadius={{
              base: "0",
              sm: "0",
              md: "24px",
              lg: "24px",
              xl: "24px",
              "2xl": "24px",
            }}
            boxShadow="lg"
            p={{
              base: "25px",
              sm: "15px",
              md: "40px",
              lg: "25px",
              xl: "25px",
              "2xl": "15px",
            }}
          >
            <Stack direction={{ base: "column", md: "row" }}>
              <Flex
                p={"2%"}
                color={"white"}
                flex={1}
                align={"center"}
                justify={"center"}
                ml={"5px"}
              >
                <Stack spacing={4} w={"full"} maxW={"md"}>
                  <Box w={"268px"} h={"80px"}>
                    <Image
                      alt={"Login Image"}
                      marginBottom={"10px"}
                      width={"29px"}
                      src={arrow}
                      display={"none"}
                    />
                    <Heading
                      color={"#ffffff"}
                      paddingTop={1}
                      fontSize={"28px"}
                      fontWeight={500}
                      letterSpacing={0}
                      lineHeight={"normal"}
                    >
                      Create an account
                    </Heading>
                    <Flex gap={"5px"}>
                      <Text
                        fontWeight={400}
                        fontFamily={("Poppins-Regular", "Helvetica")}
                        color={"white"}
                        fontSize={"15px"}
                        lineHeight={"normal"}
                        letterSpacing={0}
                      >
                        Already have an account?{" "}
                      </Text>

                      <Link to="/login">
                        <Text
                          color={"blue.500"}
                          fontWeight={400}
                          fontFamily={("Poppins-Regular", "Helvetica")}
                          fontSize={"15px"}
                          lineHeight={"normal"}
                          letterSpacing={0}
                          cursor="pointer"
                        >
                          Sign in
                        </Text>
                      </Link>
                    </Flex>
                  </Box>
                  <FormControl id="username">
                    <FormLabel
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      fontWeight={400}
                      fontSize={"0.8em"}
                      color={"#d5d5d5"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      Username
                    </FormLabel>
                    <Input
                      {...register("username", { required: true })}
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type="text"
                    />
                    {errors.username && <span>This field is required</span>}
                  </FormControl>
                  <FormControl id="email">
                    <FormLabel
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      fontWeight={400}
                      fontSize={"0.8em"}
                      color={"#d5d5d5"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                    >
                      Email address
                    </FormLabel>
                    <Input
                      {...register("email", { required: true })}
                      color={"white"}
                      borderColor={"#66666680"}
                      variant={"outline"}
                      borderWidth={1}
                      backgroundColor={"#020B19"}
                      type="email"
                    />
                    {errors.email && <span>This field is required</span>}
                  </FormControl>
                  <Flex gap={4}>
                    <FormControl id="password">
                      <FormLabel
                        fontFamily={("Poppins-Regular", "Helvetica")}
                        fontWeight={400}
                        fontSize={"0.8em"}
                        color={"#d5d5d5"}
                        lineHeight={"normal"}
                        letterSpacing={0}
                      >
                        Password
                      </FormLabel>
                      <Input
                        backgroundColor={"#020B19"}
                        borderColor={"#66666680"}
                        borderWidth={1}
                        variant={"outline"}
                        {...register("password", {
                          required: true,

                          // pattern: /^[A-Za-z]+$/i,
                          minLength: 8,
                        })}
                        type={show ? "text" : "password"}
                      />
                    </FormControl>
                    <FormControl id="cpassword">
                      <FormLabel
                        fontFamily={("Poppins-Regular", "Helvetica")}
                        fontWeight={400}
                        fontSize={"0.8em"}
                        color={"#d5d5d5"}
                        lineHeight={"normal"}
                        letterSpacing={0}
                      >
                        Confirm your password
                      </FormLabel>
                      <Input
                        backgroundColor={"#020B19"}
                        borderColor={"#66666680"}
                        borderWidth={1}
                        variant={"outline"}
                        {...register("cpassword", {
                          required: true,

                          // pattern: /^[A-Za-z]+$/i,
                          minLength: 8,
                        })}
                        type={show ? "text" : "password"}
                      />
                    </FormControl>
                  </Flex>
                  {errors.password && (
                    <Text
                      fontFamily={("Poppins-Regular", "Helvetica")}
                      fontWeight={400}
                      color={"#d5d5d5"}
                      lineHeight={"normal"}
                      letterSpacing={0}
                      fontSize={"0.8em"}
                    >
                      Use 8 or more characters with a mix of letters,numbers{" "}
                      <span dangerouslySetInnerHTML={{ __html: "&#038" }} />{" "}
                      symbols
                    </Text>
                  )}

                  <Stack spacing={6}>
                    <Stack
                      direction={{ base: "column", sm: "row" }}
                      align={"start"}
                      justify={"space-between"}
                    >
                      <Checkbox
                        color={"#cbcbcb"}
                        onChange={(e) => setShow(!show)}
                      >
                        Show Password
                      </Checkbox>
                    </Stack>

                    <Stack
                      align={{
                        base: "center",
                        sm: "center",
                        md: "end",
                        lg: "end",
                        xl: "end",
                        "2xl": "end",
                      }}
                    >
                      <Button
                        borderRadius={24}
                        bg={"#0076FF"}
                        w={"150px"}
                        type="submit"
                        h={"50px"}
                        variant={"solid"}
                        _hover={{ background: "#7182f5" }}
                      >
                        {loading ? <Spinner /> : "Continue"}
                      </Button>
                    </Stack>
                  </Stack>
                </Stack>
              </Flex>

              <Flex
                justify="center"
                align="center"
                display={["none", "none", "none", "flex"]}
              >
                <Image
                  alt={"Login Image"}
                  marginTop={6}
                  height={"350px"}
                  width={"250px"}
                  objectFit={"cover"}
                  src={logo}
                />
              </Flex>
            </Stack>
          </Box>

          <Flex mr={5} ml={5} justify={"space-between"}>
            <Box>
              <Select fontSize={".9em"} color={"white"} w="auto">
                <option value="en"> English(Unites states)</option>
              </Select>
            </Box>
            <Box mt={2}>
              <Flex mr={10} justify={"space-evenly"}>
                <Text fontSize={12} color={"white"}>
                  Help
                </Text>
                <Text fontSize={12} ml={"24px"} color={"white"}>
                  Privacy
                </Text>
                <Text fontSize={12} ml={"24px"} color={"white"}>
                  Terms
                </Text>
              </Flex>
            </Box>
          </Flex>
        </Grid>
      </Center>
    </>
  );
}

export default EmailScreen;
